import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { AnalystInterface } from 'src/app/util/interfaces/register/analyst';
import { SolutionAreaInterface } from 'src/app/util/interfaces/register/solutionArea';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class GroupManagerAnalystsService {
	private getAnalystsByCustomerIdUrl = environment.baseApiUrl + 'register/analystsByCustomer';
	private getSolutionAreasByAnalystIdUrl = environment.baseApiUrl + 'register/solutionAreasByAnalyst';
	private solutionAreasByAnalystUrl = environment.baseApiUrl + 'register/solutionAreasByAnalyst';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	getAnalystsByCustomerId(): Observable<AnalystInterface[]> {
		return this.http.get<AnalystInterface[]>(this.getAnalystsByCustomerIdUrl, { headers: this.headers });
	}

	getSolutionAreasByAnalystId(): Observable<SolutionAreaInterface[]> {
		return this.http.get<SolutionAreaInterface[]>(this.getSolutionAreasByAnalystIdUrl, { headers: this.headers });
	}

	getAnalystBySolutionAreasId(idSolutionArea: number): Observable<AnalystInterface[]> {
		return this.http.get<AnalystInterface[]>(`${this.getSolutionAreasByAnalystIdUrl}/${idSolutionArea}`, { headers: this.headers });
	}

	insertAnalystsToSolutionArea(idSolutionArea: number, analystIds: number[]): Observable<any> {
		return this.http.post(`${this.solutionAreasByAnalystUrl}/${idSolutionArea}`, { analystIds }, { headers: this.headers });
	}
}
